import * as React from 'react';

const TitleEditSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2v3h1V3h5v10H6v1h5v-1H9V3h5v2h1V2H2z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M15 9h7v1h-7zM15 13h7v1h-7zM6 17h16v1H6zM6 21h16v1H6z" />
        </g>
    </svg>
);

TitleEditSvg.displayName = 'TitleEditSvg';
export default TitleEditSvg;
